import { observeElements } from './_animations.js';

const feedGridContainer = document.querySelector('.feed__container');
const feedLoadMore = document.querySelector('.feed__load-more a');

if (feedLoadMore) {
  const feedLoadMoreText = feedLoadMore.querySelector('span').textContent;
  const feedPostType = feedLoadMore.parentElement.dataset.postType;
  const feedPostsPerPage = feedLoadMore.parentElement.dataset.postsPerPage;
  const feedSegmentation = feedLoadMore.parentElement.dataset.segmentation;
  const feedOrderby = feedLoadMore.parentElement.dataset.orderby;
  const feedDownloadContext = feedLoadMore.parentElement.dataset.downloadContext;
  const filtersForm = document.querySelector('.filters form');

  // Start from the batch the server rendered (/page/N/), so "Load More" continues from there
  let feedPage = parseInt(feedLoadMore.parentElement.dataset.currentPage || '1', 10);
  const feedBaseUrl = feedLoadMore.parentElement.dataset.baseUrl;
  let isFetching = false; // Add this variable to track fetch requests

  const getFeedPosts = (visibleIds = null) => {
    showFeedLoader();
    const formData = new FormData();
    formData.append('page', feedPage);
    formData.append('postType', feedPostType);
    formData.append('postsPerPage', feedPostsPerPage);
    formData.append('feedSegmentation', feedSegmentation);
    formData.append('feedOrderby', feedOrderby);
    formData.append('action', 'get_feed_posts');
    formData.append('downloadContext', feedDownloadContext);

    // Append viewport details to the formData
    if (Array.isArray(visibleIds)) {
      formData.append('ids', visibleIds);
    }

    // Append filters to the formData
    if (filtersForm) {
      // Experiences
      const filterOutcomesInput = filtersForm.querySelector('[name="form_outcomes"]');
      const filterOutcomes = filterOutcomesInput ? filterOutcomesInput.value : null;
      if (filterOutcomes) formData.append('filter_outcomes', filterOutcomes);

      const filterFormatsInput = filtersForm.querySelector('[name="form_formats"]');
      const filterFormats = filterFormatsInput ? filterFormatsInput.value : null;
      if (filterFormats) formData.append('filter_formats', filterFormats);

      const filterGroupsInput = filtersForm.querySelector('[name="form_groups"]');
      const filterGroups = filterGroupsInput ? filterGroupsInput.value : null;
      if (filterGroups) formData.append('filter_groups', filterGroups);

      const filterDurationInput = filtersForm.querySelector('[name="form_duration"]');
      const filterDuration = filterDurationInput ? filterDurationInput.value : null;
      if (filterDuration) formData.append('filter_duration', filterDuration);

      // Venues
      const filterCountiesInput = filtersForm.querySelector('[name="form_county"]');
      const filterCounties = filterCountiesInput ? filterCountiesInput.value : null;
      if (filterCounties) formData.append('filter_counties', filterCounties);

      // Global
      const searchText = filtersForm.querySelector('[name="form_search"]').value;
      if (searchText) {
        formData.append('search', searchText);
      }
    }

    fetch(tcc_ajax.ajax_url, {
      method: 'POST',
      body: formData
    })
    .then(response => response.json()) // Parse the response as JSON
    .then(data => {
      const posts = data.posts;
      const totalPages = data.total_pages;

      // Update the data-total-pages attribute with the total pages from the response
      feedLoadMore.parentElement.dataset.totalPages = totalPages;

      if (feedPage == 1) {
        feedGridContainer.innerHTML = posts; // Replace the content if it's the first page
      } else {
        feedGridContainer.insertAdjacentHTML('beforeend', posts); // Append the content for subsequent pages
      }

      // Keep the button's link pointing at the next batch, for crawlers and no-JS visitors
      if (feedBaseUrl && feedPage < totalPages) {
        feedLoadMore.setAttribute('href', `${feedBaseUrl}page/${feedPage + 1}/`);
      }

      // Check if we've reached the last page
      if (feedPage >= totalPages) {
        feedLoadMore.parentElement.classList.add('hidden'); // Hide the load more button if no more pages
      } else {
        feedLoadMore.parentElement.classList.remove('hidden');
      }

      isFetching = false; // Set isFetching to false to indicate the request has completed
      feedLoadMore.querySelector('span').textContent = feedLoadMoreText;

      // Observe the new elements
      const newElements = feedGridContainer.querySelectorAll('[data-fade-up]:not(.faded-up)');
      observeElements(newElements);
    })
    .finally(() => {
      hideFeedLoader();
    });
  }

  function showFeedLoader() {
    feedGridContainer.setAttribute('data-loading', 'true');
    if (!feedGridContainer.querySelector('.loader')) {
      const loader = document.createElement('div');
      loader.className = 'loader';
      loader.setAttribute('role', 'status');
      loader.setAttribute('aria-live', 'polite');
      loader.innerHTML = `
        <div class="loader__grid">
          ${'<div class="loader__cell"></div>'.repeat(9)}
        </div>
      `;
      feedGridContainer.appendChild(loader);
    }
  }

  function hideFeedLoader() {
    feedGridContainer.removeAttribute('data-loading');
    const loader = feedGridContainer.querySelector('.loader');
    if (loader) loader.remove();
  }

  if (feedLoadMore) {
    feedLoadMore.addEventListener('click', e => {
      e.preventDefault();
      if (isFetching) return; // Check if a request is in progress
      isFetching = true; // Set isFetching to true to indicate a request is starting
      feedLoadMore.querySelector('span').textContent = 'Loading...';

      const maxPages = parseInt(feedLoadMore.parentElement.dataset.totalPages);
      feedPage++;

      getFeedPosts();
    });
  }

  // Event listeners for filters
  if (filtersForm) {
    const filterElements = filtersForm.querySelectorAll('input, select');

    filtersForm.addEventListener('submit', e => {
      e.preventDefault();
    });

    filtersForm.addEventListener('reset', () => {
      setTimeout(() => {
        feedPage = 1;
        getFeedPosts();
      })
    });
  
    filterElements.forEach(element => {
      // Handle 'change' events immediately
      element.addEventListener('change', () => {
        feedPage = 1; // Reset to first page when filters change
        getFeedPosts();
      });
  
      // Use debouncing for 'input' events to avoid multiple triggers while typing
      let debounceTimer;
      element.addEventListener('input', () => {
        clearTimeout(debounceTimer); // Clear the timer on every input
        debounceTimer = setTimeout(() => {
          feedPage = 1; // Reset to first page when filters change
          getFeedPosts();
        }, 250); // Adjust delay as needed
      });
    });
  }

  const searchToggle = document.getElementById('map-searchable');
  if (searchToggle) {
    searchToggle.addEventListener('change', () => {
      if (searchToggle.checked) {
        // Simulate a viewport change to get current visible IDs
        fireVisibleMarkersEvent();
      } else {
        // When disabling, just show all posts
        document.dispatchEvent(
          new CustomEvent('mapVisibleMarkersChanged', { detail: [] })
        );
      }
    });
  }

  document.addEventListener('mapVisibleMarkersChanged', ({ detail }) => {
    const searchToggle = document.getElementById('map-searchable');
    const isEnabled = searchToggle?.checked;

    if (isEnabled && Array.isArray(detail) && detail.length > 0) {
      feedPage = 1;
      getFeedPosts(detail);
    } else {
      feedPage = 1;
      getFeedPosts();
    }
  });
}
